module.exports = __webpack_public_path__ + "img/help-support-active-icon.09196cee.svg";